export enum UserConstants {
    USER_LOGIN = 'USER_LOGIN',
    USER_CHANGE_LANGUAGE = 'USER_CHANGE_LANGUAGE',
    USER_SET_IS_AUTORIZED = 'USER_SET_IS_AUTORIZED'
}